import { useTemplateData } from "./useTemplateData";

// Resolves the voice that TTS playback should use for a given section: the
// chapter's persisted presenter override (mediaGenerationSettings.chapters[].presenter_id)
// if one exists, otherwise the project-level default presenter. Mirrors what
// the backend resolves server-side from section_id, so it can be used as a
// cache key to bust stale audio when the section's avatar/voice changes.
export const useSectionVoiceId = (sectionId?: string): string | undefined => {
  const {
    templatesData: { presenter, projectPresenters },
    mediaGenerationSettingsData: { mediaGenerationSettings },
  } = useTemplateData();

  const chapterPresenterId = sectionId
    ? mediaGenerationSettings?.chapters.find(
        (chapter) => chapter.chapter_id === sectionId
      )?.presenter_id
    : undefined;

  const chapterPresenter = chapterPresenterId
    ? projectPresenters?.find((p) => p.id === chapterPresenterId)
    : undefined;

  return (chapterPresenter ?? presenter)?.voice_profile.id;
};
